module.exports = __webpack_public_path__ + "static/img/step4.f8ae3af1.png";